module.exports = __webpack_public_path__ + "img/2002.79088103.jpg";